import {
    GET_ACTIVE_ASSET_REPORT_EXCEL_DATA,
    SET_ACTIVE_ASSET_REPORT_EXCEL_DATA,
    SET_ACTIVE_ASSET_REPORT_GRID_FILTERS,
    GET_ACTIVE_ASSET_REPORT_GRID_DATA,
    SET_ACTIVE_ASSET_REPORT_GRID_DATA,
    GET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA,
    SET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA,
    SET_IS_REPORT_GRID_DATA_LOADING
} from "./ActiveAssetReportType"

const getActiveAssetReportExcelData = (payload: any) => ({
    type: GET_ACTIVE_ASSET_REPORT_EXCEL_DATA,
    payload
});

const setActiveAssetReportExcelData = (activeAssetReportExcelData: any) => ({
    type: SET_ACTIVE_ASSET_REPORT_EXCEL_DATA,
    activeAssetReportExcelData
})

const setActiveAssetReportGridFilter = (activeAssetReportGridFilters: any) => ({
    type: SET_ACTIVE_ASSET_REPORT_GRID_FILTERS,
    activeAssetReportGridFilters
})

const getActiveAssetReportGridData = (payload: any) => ({
    type: GET_ACTIVE_ASSET_REPORT_GRID_DATA,
    payload
});

const setActiveAssetReportGridData = (activeAssetReportGridData: any) => ({
    type: SET_ACTIVE_ASSET_REPORT_GRID_DATA,
    activeAssetReportGridData
})

const getActiveAssetReportDropdownGridData = () => ({
    type: GET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA
});

const setActiveAssetReportDropdownGridData = (activeAssetReportDropdownGridData: any) => ({
    type: SET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA,
    activeAssetReportDropdownGridData
})

const setIsReportGridDataLoading = (isReportGridDataLoading: any) => ({
    type: SET_IS_REPORT_GRID_DATA_LOADING,
    isReportGridDataLoading
})

export {
    getActiveAssetReportExcelData,
    setActiveAssetReportExcelData,
    setActiveAssetReportGridFilter,
    getActiveAssetReportGridData,
    setActiveAssetReportGridData,
    setIsReportGridDataLoading,
    getActiveAssetReportDropdownGridData,
    setActiveAssetReportDropdownGridData
}